import React from "react";
import { useUI } from "@/contexts/ui.context";
import { useRouter } from "next/router";
export default function Hamburger({ color = "bg-white" }) {
  const router = useRouter();
  const genericHamburgerLine = `h-[1.5px] shrink-0 ${
    router?.pathname === "/media" ? "bg-darkGrey" : "bg-white"
  } rounded-xl transition ease transform duration-300`;
  const { isMenuOpen, setIsMenuOpen } = useUI();
  return (
    <button
      className={`left-auto ml-2 w-[24px] h-[21.5px] lg:hidden flex flex-col justify-around items-center group outline-none overflow-hidden focus:outline-none transform transition-all duration-300 ease delay-100`}
      aria-label="menu-button"
      onClick={() => setIsMenuOpen(!isMenuOpen)}
    >
      <div
        className={`${genericHamburgerLine} w-full mr-auto ${
          isMenuOpen ? "rotate-45 translate-y-[7px] translate-x-0" : "rotate-0"
        }`}
      />
      <div
        className={`${genericHamburgerLine} w-2/3 ml-auto ${
          isMenuOpen ? "opacity-0 -translate-x-2" : "opacity-100"
        } `}
      />
      <div
        className={`${genericHamburgerLine} ${
          isMenuOpen
            ? "-rotate-45 -translate-y-[7px] -translate-x-0 opacity-100 mr-0 w-full"
            : "w-1/2"
        } ml-auto`}
      />
    </button>
  );
}
